import {
  GET_OVERTIME_INACTIVE_REQUESTS_ERROR,
  GET_OVERTIME_INACTIVE_REQUESTS_PENDING,
  GET_OVERTIME_INACTIVE_REQUESTS_SUCCESS,
  GET_TIME_ADJUSTMENT_INACTIVE_REQUESTS_ERROR,
  GET_TIME_ADJUSTMENT_INACTIVE_REQUESTS_PENDING,
  GET_TIME_ADJUSTMENT_INACTIVE_REQUESTS_SUCCESS,
  SET_OVERTIME_FILTER,
  SET_OVERTIME_INACTIVE_REQUESTS,
  SET_OVERTIME_STATUS_LIST_ASYNC,
  SET_TIME_ADJUSTMENT_INACTIVE_REQUESTS,
} from './constants';

const INIT_STATE = {
  overTimeInactiveRequests: [],
  timeAdjustmentInactiveRequests: [],
  isGetOverTimeInactiveRequests: false,
  isGetTimeAdjustmentInactiveRequests: false,
  overTimeStatusList: [],
  overTimeFilter: {
    startDate: null,
    endDate: null,
    status: { label: 'All', value: '99' },
  },
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case GET_OVERTIME_INACTIVE_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetOverTimeInactiveRequests: true,
      };
    }
    case GET_OVERTIME_INACTIVE_REQUESTS_SUCCESS: {
      return {
        ...localState,
        isGetOverTimeInactiveRequests: false,
      };
    }
    case GET_OVERTIME_INACTIVE_REQUESTS_ERROR: {
      return {
        ...localState,
        isGetOverTimeInactiveRequests: false,
      };
    }
    case SET_OVERTIME_INACTIVE_REQUESTS: {
      return {
        ...localState,
        overTimeInactiveRequests: action.payload,
      };
    }
    case GET_TIME_ADJUSTMENT_INACTIVE_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetTimeAdjustmentInactiveRequests: true,
      };
    }
    case GET_TIME_ADJUSTMENT_INACTIVE_REQUESTS_SUCCESS: {
      return {
        ...localState,
        isGetTimeAdjustmentInactiveRequests: false,
      };
    }
    case GET_TIME_ADJUSTMENT_INACTIVE_REQUESTS_ERROR: {
      return {
        ...localState,
        isGetTimeAdjustmentInactiveRequests: false,
      };
    }
    case SET_TIME_ADJUSTMENT_INACTIVE_REQUESTS: {
      return {
        ...localState,
        timeAdjustmentInactiveRequests: action.payload,
      };
    }
    case SET_OVERTIME_STATUS_LIST_ASYNC: {
      const { overTimeStatusList } = action.payload;
      return {
        ...localState,
        overTimeStatusList,
      };
    }
    case SET_OVERTIME_FILTER: {
      return {
        ...localState,
        overTimeFilter: action.payload,
      };
    }
    default:
      return { ...localState };
  }
};
